export default __webpack_public_path__ + "static/media/1892.60ec0ec3.png";